import {
  Box,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { useRoleContext } from "hooks";

interface Props {
  notes: string;
  onNotesUpdate: (newValue: string) => void;
  loading: boolean;
  error: string | null;
  pickupTimestamp: string;
  onPickupTimestampUpdate: (newValue: string) => void;
}

export function MarkShipmentAsPickedUpModalContent(props: Props) {
  const {
    loading,
    notes,
    onNotesUpdate,
    error,
    pickupTimestamp,
    onPickupTimestampUpdate,
  } = props;
  const { role } = useRoleContext();

  if (loading || !role) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }
  return (
    <Stack direction="column" spacing={2}>
      <Typography>
        Marking a shipment as picked up will update the shipment status. This
        action can not be reversed.
      </Typography>
      <Typography variant="h6" sx={{ mt: ".5rem" }}>
        When was the shipment picked up?
      </Typography>
      <TextField
        id="datetime-local"
        label="Pick up date & time"
        type="datetime-local"
        value={pickupTimestamp}
        onChange={(e) => onPickupTimestampUpdate(e.target.value)}
      />
      <Box mb="2rem">
        <TextField
          id="pickup-notes"
          variant="outlined"
          onChange={(e) => onNotesUpdate(e.target.value)}
          value={notes}
          sx={{ width: "100%" }}
          multiline
          maxRows={20}
          minRows={1}
          placeholder="Example: Picked up without issues."
          label="Optional additional notes"
          autoFocus
        />
        <Typography variant="body2" color="text.secondary">
          Notes and pick up time will be shared with the{" "}
          {role.type === "CARRIER" ? "shipper" : "carrier"}.
        </Typography>
      </Box>

      {error != null && !loading && (
        <Typography color="red" align="center">
          {error}
        </Typography>
      )}
    </Stack>
  );
}
